import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { useTranslation } from "@/hooks/useTranslation";
import { ColumnDef } from "@tanstack/react-table";
import { AdminUserTeamDTO } from "@shaarp/common";
import { RiExternalLinkFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import DataTableCellAdminUserTeamLicence from "./data-table-cell-admin-user-team-licence";
import DataTableCellAdminUserTeamRole from "./data-table-cell-admin-user-team-role";

export const dataTableAdminUserTeamsColumns = () => {
  const { t } = useTranslation();

  return [
    {
      id: "Equipe",
      accessorFn: (team: AdminUserTeamDTO) => team.name,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsers.dialogs.teams.columns.team")}
        />
      ),
      cell: ({ row }) => {
        const team = row.original;
        const teamUrl = `/administration/teams?query=${team.id}`;
        return (
          <div className="flex items-center gap-1.5">
            <Link
              to={teamUrl}
              className="font-medium text-primary underline-offset-4 hover:underline"
            >
              {team.name}
            </Link>
            <Link
              to={teamUrl}
              target="_blank"
              rel="noopener noreferrer"
              title={t(
                "admin.dataTableAdminUsers.dialogs.teams.openInNewTab"
              )}
              className="text-primary hover:opacity-70"
            >
              <RiExternalLinkFill className="w-3.5 h-3.5" />
            </Link>
          </div>
        );
      },
    },
    {
      id: "Role",
      accessorKey: "role",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsers.dialogs.teams.columns.role")}
        />
      ),
      cell: ({ row }) => {
        const user = row.original;
        return <DataTableCellAdminUserTeamRole role={user?.role} />;
      },
    },
    {
      id: "Licence",
      accessorKey: "licence",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsers.dialogs.teams.columns.licence")}
        />
      ),
      cell: ({ row }) => {
        const team = row.original;
        return <DataTableCellAdminUserTeamLicence teams={team} />;
      },
    },
    {
      id: "Rejoint le",
      accessorFn: (team) => team.createdAt,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsers.dialogs.teams.columns.joinedAt")}
        />
      ),
      cell: ({ row }) => {
        const date = new Date(row.original.createdAt);
        return (
          <span>
            {date.toLocaleDateString("fr-FR")}{" "}
            {date.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) }
          </span>
        )
      },
    }
  ] as ColumnDef<AdminUserTeamDTO>[];
};